/* Resuelve el tema ANTES del primer pintado.
   Va sin defer y lo mas arriba posible del <head> a proposito: si se
   retrasa, la pagina pinta en claro y luego salta a oscuro. Pesa menos
   de medio kilobyte y sale del mismo CDN que el resto de assets. */
(function () {
  var h = document.documentElement;
  var t = null;
  try { t = localStorage.getItem('pw-tema'); } catch (e) {}
  if (t !== 'claro' && t !== 'oscuro') {
    t = (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'oscuro' : 'claro';
    h.setAttribute('data-pw-auto', '1');
  }
  h.setAttribute('data-pw-tema', t);
  if (t === 'oscuro') h.classList.add('pw-oscuro');
})();
